import { useRef } from "react";
import { buildMediaUrl } from "../../../utils/mediaType";

type QuestionVideoProps = {
  media: string;
  retryKey?: number;
  onError?: () => void;
  onLoad?: () => void;
};

const QuestionVideo = ({ media, retryKey = 0, onError, onLoad }: QuestionVideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleError = () => {
    onError?.();
  };

  return (
    <div className="relative 2xl:max-h-[56vh] xl:max-h-[53vh] lg:max-h-[50vh] h-full max-h-[200px] landscape:max-lg:max-h-[200px]  flex-1 2xl:mt-[0.5vw] lg:mt-3 mt-1 w-full 2xl:max-w-[58vw] xl:max-w-[55vw] max-w-[600px] landscape:max-lg:max-w-[400px] mx-auto 2xl:rounded-[0.83vw] xl:rounded-2xl rounded-xl overflow-hidden">
      <video
        controls
        className="w-full h-full object-contain 2xl:rounded-[0.83vw] xl:rounded-2xl rounded-xl"
        playsInline
        src={buildMediaUrl(media, retryKey)}
        ref={videoRef}
        onError={handleError}
        onLoadedData={onLoad}
      />
    </div>
  );
};

export default QuestionVideo;
